import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueProgressBar from "vue-progressbar";
import BlockUI from "vue-blockui";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Paginate from "vuejs-paginate";
import authService from "@/services/authService.js";
import { VueStars } from "vue-stars";
import eventBus from "@/plugins/eventBus.js";
import helper from "@/plugins/global.js";
import { currencyFormat } from "./helpers/numberHelper";
import loader from "@/components/shared/Loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueCurrencyInput from "vue-currency-input";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import VueNotification from "@kugatsu/vuenotification";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Vuelidate from "vuelidate";
import { extractTextAfterGMT } from "./helpers/numberHelper";
import VueQuillEditor from "vue-quill-editor";
import { firebaseAuth } from "@/plugins/firebase.js";

import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme

const gmtNumber = extractTextAfterGMT(
  Intl.DateTimeFormat("en-US", {
    dateStyle: "full",
    timeStyle: "long"
  }).format()
);

Vue.use(VueQuillEditor);
Vue.use(VueProgressBar, {
  color: "#4FB848",
  failedColor: "#874b4b",
  thickness: "3px",
  transition: {
    speed: "1s",
    opacity: "0.6s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
});
Vue.use(BlockUI);
Vue.use(VueCurrencyInput);
Vue.use(Cropper);
Vue.use(VueNotification, {
  timer: 5,
  position: "topRight",
  showLeftIcn: true,
  showCloseIcn: true,
  buttonClicked: true
});
Vue.use(Vuelidate);

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.component("paginate", Paginate);
Vue.component("vue-stars", VueStars);
Vue.component("loader", loader);
Vue.component("v-select", vSelect);
Vue.component("Multiselect", Multiselect);

Vue.config.productionTip = false;

axios.interceptors.request.use(
  async config => {
    if (router.app !== null) {
      router.app.$Progress.start();
    }

    config.headers.Timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers.TimezoneAbbr = gmtNumber;
    // config.headers.Authorization = `Bearer ${await auth.getAcessToken()}`
    config.headers.Currency = localStorage.getItem("selectedCurrency") || "SGD";

    const publicRouteSetup = config.headers["_pub"];

    if (!publicRouteSetup || publicRouteSetup === "false") {
      config.headers.Authorization = `Bearer ${await store.dispatch(
        "user/getToken"
      )}`;
    }

    return config;
  },
  error => {
    if (router.app !== null) {
      router.app.$Progress.fail();
    }
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    // complete the progress bar
    if (router.app !== null) {
      router.app.$Progress.finish();
    }
    return response;
  },
  error => {
    if (router.app !== null) {
      router.app.$Progress.fail();
    }
    if (error.response && error.response.status === 401 && error.config) {
      router.push({
        path: "/logout"
      });
    } else if (error.message === "Network Error") {
      router.push({
        path: "/server-error"
      });
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$authService = authService;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$helper = helper;
Vue.prototype.$currencyFormat = currencyFormat;

if (!firebaseAuth.currentUser) {
  firebaseAuth
    .signInWithEmailAndPassword("app.core@trransfer.com", "trransfer123")
    .then(() => {
      console.log("Firebase: Signed in automatically.");
    })
    .catch(err => {
      console.error("Auto sign-in failed:", err.message);
    });
}

const vm = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");

export default vm;



// WEBPACK FOOTER //
// ./src/main.js